import React from 'react'
import { Checked } from 'components/DocumentListDisplay'
import { styles } from './styles'
import { Button } from 'react-bootstrap'

interface CheckboxProps {
  checked: Checked
  toggleCheckbox: () => void
}

const UNICODE_CHECKMARK = '\u2713'

export const DocumentSelectionCheckbox = ({
  checked,
  toggleCheckbox,
}: CheckboxProps) => {
  return (
    <>
      <input type="checkbox" value={checked} style={styles.hidden} />
      <Button onClick={toggleCheckbox} variant={checked ? 'primary' : 'light'}>
        {UNICODE_CHECKMARK}
      </Button>
    </>
  )
}
